import { useQuery } from "@tanstack/react-query";
import { EnvelopeOpen, DownloadSimple } from "@phosphor-icons/react";
import { useApi } from "@/lib/api";

const ts = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : null);

const Status = ({ at, count, icon: Icon, label, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-1.5 whitespace-nowrap text-xs ${at ? "text-[#00FF9D]" : "text-[#6B6B6B]"}`}>
    <Icon size={14} /> {at ? `${ts(at)}${count > 1 ? ` · ${count}×` : ""}` : `Not ${label}`}
  </span>
);

const SendCard = ({ s }) => (
  <div data-testid={`board-send-${s.send_id}`} className="border-t border-[#2A2A2A]">
    <div className="px-6 py-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
      <span className="font-medium">Sent {ts(s.sent_at)}</span>
      <span className="font-mono text-[11px] text-[#A3A3A3]">{s.opened}/{s.recipients.length} opened · {s.downloaded}/{s.recipients.length} downloaded the PDF</span>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <tbody className="divide-y divide-[#1E1E1E]">
          {s.recipients.map((r) => (
            <tr key={r.id} data-testid={`board-track-row-${r.email}`}>
              <td className="px-6 py-2 font-mono text-xs whitespace-nowrap">{r.email}</td>
              <td className="px-3 py-2 text-[11px] text-[#A3A3A3] whitespace-nowrap">{r.role}</td>
              <td className="px-3 py-2"><Status testid={`track-opened-${r.email}`} at={r.opened_at} count={r.open_count} icon={EnvelopeOpen} label="opened" /></td>
              <td className="px-3 py-2"><Status testid={`track-downloaded-${r.email}`} at={r.downloaded_at} count={r.download_count} icon={DownloadSimple} label="downloaded" /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export const BoardTracking = () => {
  const api = useApi();
  const { data = [] } = useQuery({ queryKey: ["board-tracking"], queryFn: () => api.get("/reports/board/tracking"), refetchInterval: 60000 });
  return (
    <section data-testid="board-tracking" className="mt-4 rounded-xl border border-[#2A2A2A] bg-[#121212]">
      <div className="p-6 pb-3">
        <h3 className="font-display text-lg">Who opened the board update</h3>
        <p className="text-sm text-[#A3A3A3]">"Opened" is a best guess: some email apps block images or open every email automatically. PDF downloads are more reliable, though some email security scanners may also open links.</p>
      </div>
      {data.length === 0
        ? <p data-testid="board-tracking-empty" className="px-6 pb-6 text-sm text-[#A3A3A3]">No tracked board updates yet. Your next board email will show up here.</p>
        : data.map((s) => <SendCard key={s.send_id} s={s} />)}
    </section>
  );
};
